import { authManagementRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { loginLoader } from "@routes/authLoaders";

const permission = "all";

const authManagementRouteMetadata: IRouteMetadataObj<
  typeof authManagementRoutesObj
> = {
  auth: {
    title: "login.title",
    description: "login.description",
    lazy: () => import("@pages/authManagement/page"),
    mode: "create",
    type: "main",
    icon: "LayoutGridLine",
    breadcrumbs: [],
    permission,
  },
};

export const authManagementRoutes = createRoute<typeof authManagementRoutesObj>(
  authManagementRoutesObj,
  authManagementRouteMetadata,
  loginLoader,
);
